import React, { useState } from 'react'
import { Select, Text } from '../'
import StyledPhoneNumber from './StyledPhoneNumber'
import wrapField from '../shared/wrapField'

const PhoneNumber = props => (
	<StyledPhoneNumber>
		<PhoneNumberField {...props}/>
	</StyledPhoneNumber>
)

const PhoneNumberField = wrapField(({ smartSubmit, onBlur, onChange, fieldApi, fieldState, noForm, value, ...props }) => {
	const codeOptions = [{
		value: '+49',
		label: '+49'
	}, {
		value: '+41',
		label: '+41'
	}, {
		value: '+43',
		label: '+43'
	}, {
		value: '+33',
		label: '+33'
	}, {
		value: '+',
		label: '+'
	}]

	const splitNumber = fullNumber => {
		let code = ''
		let number = ''

		codeOptions
			.map((option) => option.value)
			.sort((a, b) => a.length - b.length)
			.forEach(v => {
				if(fullNumber?.startsWith(v)) {
					code = v
					number = fullNumber.split(v)[1]
				}
			})
		return [code, number]
	}

	const insertSpace = (string, pos) => {
		if(string.length <= pos) {
			return string
		}
		return [string.slice(0, pos), string.slice(pos)].join(' ')
	}
	const [internalValue, setValue] = useState(null)
	const [code, number] = splitNumber(noForm ? (value ?? internalValue) : fieldState.value)

	const handleSelectorChange = (option) => {
		const out = ensureLength(option.value + number)
		if(onChange) {
			onChange(out)
		}
		if(!noForm) {
			fieldApi.setValue(out)
		} else {
			setValue(out)
		}
	}

	const handleTextChange = (e) => {
		const out = ensureLength(code + e.target.value.replace(/\D+/g, ''))
		if(onChange) {
			onChange(out)
		}
		if(smartSubmit) {
			smartSubmit.delay(e)
		}
		if(!noForm) {
			fieldApi.setValue(out)
		} else {
			setValue(out)
		}
	}

	const ensureLength = input => {
		return input.startsWith('+') ? '+' + input.slice(1, 15) : input.slice(0, 14)
	}

	let displayNumber = number

	if(code === '+41') { // switzerland code
		displayNumber = insertSpace(displayNumber, 2)
		displayNumber = insertSpace(displayNumber, 7) // at pos 6 (spaces are counted as well)
		displayNumber = insertSpace(displayNumber, 11) // at pos 9 (spaces are counted as well)
	} else {
		displayNumber = insertSpace(displayNumber, 3)
	}

	return(
		<>
			<Select
				noForm
				inline
				simpleValue
				value={code}
				onChange={handleSelectorChange}
				options={codeOptions}
			/>
			<Text
				inline
				noForm
				value={displayNumber}
				onChange={handleTextChange}
				onBlur={(e) => {
					if(onBlur) {
						onBlur(e)
					}
					if(smartSubmit) {
						smartSubmit.submit(e)
					}
				}}
				{...props}
			/>
		</>
	)
})

export default PhoneNumber
